export const ApiTab = (props: any) => {
  return (
    <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_3968_44118" maskUnits="userSpaceOnUse" x="0" y="0" width="14" height="13">
        <path
          d="M11.3337 5.83198L10.3337 6.83198L6.66699 3.16531L7.66699 2.16531C8.16699 1.66531 10.0003 0.831979 11.3337 2.16531C12.667 3.49865 11.8337 5.33198 11.3337 5.83198Z"
          fill="white"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M12.9997 0.5L11.333 2.16667" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
        <path
          d="M2.66629 7.16797L3.66629 6.16797L7.33296 9.83464L6.33296 10.8346C5.83296 11.3346 3.99962 12.168 2.66629 10.8346C1.33296 9.5013 2.16629 7.66797 2.66629 7.16797Z"
          fill="white"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.66667 9.16667L8 7.83333M1 12.5L2.66667 10.8333M4.33333 6.83333L5.66667 5.5"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </mask>
      <g mask="url(#mask0_3968_44118)">
        <path d="M-1 -1.5H15V14.5H-1V-1.5Z" fill={props.active ? 'white' : 'black'} />
      </g>
    </svg>
  );
};
